import { ApolloError } from "@apollo/client";

import { StaffRole } from "../generated/graphql";

// Every staff role in the order the portal lists them.
export const STAFF_ROLES: StaffRole[] = [
  StaffRole.Admin,
  StaffRole.Management,
  StaffRole.CustomerService,
  StaffRole.CustomerSuccess,
  StaffRole.Operations,
  StaffRole.Finance,
  StaffRole.Marketing,
];

// The codes the staff API refuses a request with; each has a message.
const KNOWN_ERROR_CODES = new Set([
  "last-admin",
  "staff-member-not-found",
  "staff-email-registered",
  "staff-email-company-plus-address",
  "staff-invitation-pending",
  "staff-roles-required",
  "invalid-email",
  "staff-invitation-not-found",
]);

// The message key for a refused request; null for an unexpected error.
export const staffManagementErrorKey = (error: unknown): string | null => {
  const code = error instanceof ApolloError ? error.graphQLErrors[0]?.message : undefined;
  return code && KNOWN_ERROR_CODES.has(code) ? `team.errors.${code}` : null;
};
